import axios, { AxiosRequestConfig, AxiosInstance } from 'axios'
import config from '../config'

const commonConfig: AxiosRequestConfig = {
  timeout: 1500000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  baseURL: config.EXPLORER_BACKEND_URL,
}

const axiosInstance: AxiosInstance = axios.create(commonConfig)

axiosInstance.interceptors.request.use(
  (config) => {
    return config
  },
  (error: any) => {
    return Promise.reject(error)
  },
)

axiosInstance.interceptors.response.use((response) => {
  return response
})

export { axiosInstance }
